/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type OrderProcessingStatus =
  typeof OrderProcessingStatus[keyof typeof OrderProcessingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderProcessingStatus = {
  RECEIVED: 'RECEIVED',
  INGESTING: 'INGESTING',
  PROCESSING: 'PROCESSING',
  REJECTED: 'REJECTED',
  REJECTED_SENT: 'REJECTED_SENT',
  COMPLETED: 'COMPLETED',
} as const;
